import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/opportunities-details'
)({
  component: () => <div>CleanerBookingDetails</div>,
});
